import { useEffect } from 'react';
import { fetchResultsEffect } from './fetchResultsEffect';
import { UseChangeParams } from './UseChangeParams.type';

export const useSearchQueryChange = ({
    config,
    state,
    dispatch,
    isInitialRender,
    isAfterReset,
    setIsAfterReset,
    resetState,
    searchSuccess,
    Persistence,
    emitEvent,
    createSearchEvent,
    createResetQueryEvent,
    updateError,
    abortController,
    isDebugMode,
}: UseChangeParams) => {
    useEffect(() => {
        fetchResultsEffect(
            {
                dispatch,
                isInitialRender,
                searchQuery: state.searchQuery,
                isAfterReset,
                setIsAfterReset,
                resetState,
                Persistence,
                apiUrl: config.apiUrl,
                sets: state.sets,
                controls: state.controls,
                initialPagination: state.initialPagination,
                searchSuccess,
                emitEvent,
                createSearchEvent,
                createResetQueryEvent,
                updateError,
                abortController,
                isDebugMode,
                isInstantSearch: state.isInstantSearch,
            },
            { emitSearchEvent: true }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.searchQuery]);
};
